import React from 'react';
import { useParams } from 'react-router-dom';
import MeetingDetailsView from './MeetingDetailsView';

export default function MeetingDetailsViewPathWrapper(props) {
  const { isAdministratorView } = props;
  const { teamId, meetingId } = useParams();
  return <MeetingDetailsView teamId={teamId} meetingId={meetingId} isAdministratorView={isAdministratorView} />;
}
